@if (selectedTask(); as task) {
	<div class="activity-preview-task-panel">
		<div class="activity-preview-task-panel__details">
			<task-details
				[task]="task"
				[totalTasks]="totalTaskCount()"
				[currentTaskIndex]="currentTaskPosition()"
				[previousButtonLabelKey]="previousButtonLabelKey()"
				(navigateBack)="onNavigateBack()"
				(navigateForward)="onNavigateForward()"
				(openNavigator)="onOpenNavigator()">
			</task-details>
		</div>

		@if (shouldShowPresentTaskAdditionalSettings()) {
			<present-task-additional-settings
				(tasksUpdated)="onTasksUpdated($event)">
			</present-task-additional-settings>
		} @else if (shouldShowReactAdditionalSettings()) {
			<react-task-additional-settings />
		}
	</div>
}
